export const getDefaultState = () => {
  return {
    newDataset: null,
    newDatasetGroup: null,
    datasets: [],
    datasetMapping: null,
    datasetGroup: null
  };
};
